import styled from 'styled-components';

import { MarkdownDisplayWrapper } from '@web/components/MarkdownDisplayWrapper';

type WrapperProps = {
  previewMode?: boolean;
};

export const Wrapper = styled(MarkdownDisplayWrapper)<WrapperProps>`
  color: ${({ theme, previewMode }) =>
    previewMode ? theme.colors.gray : theme.colors.primaryText};
  font-size: ${({ previewMode }) => (previewMode ? '12px' : '14px')};
`;
